import { Box, Link } from "@mui/material";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkTable from "../../components/atoms/TkTable";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import "./_style.scss";
import {
  fakeTableList,
  headList,
  infoHeadTitleList,
  monthMapping,
  salaryTableHead,
  schema,
  symbolHeadList,
} from "./parts";
import { useContext, useEffect, useRef, useState } from "react";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkMemo from "../../components/molecules/TkMemo";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { TkGetCode } from "../../utils/TkGetCode";
import {
  applyEvent,
  CommonOrCommonRetirementFlug,
  FacilityKind,
  FacilityType,
  InquiryCode,
  Prefectures,
  SexFlug,
  Status,
  RetireReason,
} from "../../assets/data/Constants";
import {
  changeAmountFormat,
  isStatusAfterApproval,
  isStatusAfterAwaitingReceipt,
} from "../../utils/useTools";
import {
  funInfoBodyList,
  funStatusBodyList,
  funTransferHistoryList,
  makeApprovalInfoList,
  makeSalaryList,
} from "./hooks/useHooks";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import TkLabelText from "../../components/atoms/TkLabelText";
import TkAmountInput from "../../components/molecules/TkAmountInput";
import { httpAPI_APP016, httpAPI_STA033, httpAPI_STA034 } from "./api/request";
import {
  IAPI_APP016_Request,
  IAPI_STA033_Request,
  IAPI_STA034_Response,
} from "../../type/apiType";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import _ from "lodash";
import {
  SixMonthsSalaryBeforeApplyList,
  UnrecognizedMonthList,
} from "../../type/apiType/IAPI_STA034";
import TkButton from "../../components/atoms/TkButton";
import { SCRW070004Components } from "./components/components";
import { TypeTableBody } from "../../type/componentsType/TkTable";

/**
 * SCRW070004 退職金追加支給時等 職員情報訂正
 * @return SCRW070004 退職金追加支給時等 職員情報訂正
 */
const SCRW070004 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [status, setStatus] = useState<any>();
  const [responseData, setResponseData] = useState<IAPI_STA034_Response>({});
  const location = useLocation();
  const contractorNo =
    location.state?.contractorNo ?? businessState.common?.contractorNo;
  const staffNo = location.state?.staffNo;
  const applyId = location.state?.applyId ?? businessState.job_114?.applyId;
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const [isOpen, setIsOpen] = useState(false);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [unrecognizedMonthList, setUnrecognizedMonthList] = useState<
    UnrecognizedMonthList[]
  >([]);
  interface ISixSalary extends SixMonthsSalaryBeforeApplyList {
    errorSalaryTableAmt?: string;
    errorSalaryAdjustmentAmt?: string;
  }
  const [sixMonthsSalaryBeforeApplyList, setSixMonthsSalaryBeforeApplyList] =
    useState<ISixSalary[]>([]);
  const ref = useRef<{ submit: any } | null>(null);

  // 初期化
  const handleInit = async () => {
    try {
      const res = await httpAPI_STA034({
        contractorNo,
        staffNo,
        applyId,
      });

      if (res.resultCd === "I0000") {
        setResponseData(res);
        setStatus(res.latestApplyStatus);

        const handleLinkClick = (isContractor?: boolean) => {
          setBusinessState({
            ...businessState,
            job_114: {
              ...businessState.job_114,
              applyId,
              facilityNo: res.facilityNo,
            },
          });

          if (isContractor) {
            navigate("/SCRC040101");
          } else {
            navigate("/SCRW120004", { state: { facilityNo: res.facilityNo } });
          }
        };

        const resArr = stateFakeTableList.current;

        // １段目
        // 契約者番号
        resArr.find((item) => item.keyword === "contractorNo")!.text =
          res.contractorNo;
        // 契約者名にリンクを付与
        resArr.find((item) => item.keyword === "contractorName")!.node = (
          <Link onClick={() => handleLinkClick(true)}>
            {res.contractorNo}:{res.corpName}
          </Link>
        );
        // 契約者住所
        resArr.find((item) => item.keyword === "contractorAddress")!.text = (
          <>
            〒{res.cozipcode}
            {TkGetCode(Prefectures, res.coprefectureCd)}
            {res.coaddressCity}
            {res.coaddressOthers}
          </>
        );
        // TEL
        resArr.find((item) => item.keyword === "tel")!.text = res.tel;
        // FAX
        resArr.find((item) => item.keyword === "fax")!.text = res.fax;

        // ２段目
        // 施設番号
        resArr.find((item) => item.keyword === "facilityNo")!.text =
          res.facilityNo;
        // 施設名称
        resArr.find((item) => item.keyword === "facilityName")!.node = (
          <Link onClick={() => handleLinkClick()}>{res.facilityName}</Link>
        );
        // 施設住所
        resArr.find((item) => item.keyword === "facilityAddress")!.text = (
          <>
            〒{res.zipcode}
            {TkGetCode(Prefectures, res.prefectureCd)}
            {res.addressCity}
            {res.addressOthers}
          </>
        );
        // 施設種類
        resArr.find((item) => item.keyword === "facilityType")!.text =
          TkGetCode(FacilityKind, res.facilityKind);
        // 施設区分
        resArr.find((item) => item.keyword === "facilityKbn")!.text = TkGetCode(
          FacilityType,
          res.facilityKbn
        );

        // ３段目
        // 職員名
        resArr.find(
          (item) => item.keyword === "staffName"
        )!.text = `${res.staffNo}: ${res.staffNameKanji}`;
        // 性別
        resArr.find((item) => item.keyword === "gender")!.text = TkGetCode(
          SexFlug,
          res.sex
        );
        // 職種
        resArr.find((item) => item.keyword === "jobCd")!.text = res.jobName;
        // 生年月日
        resArr.find((item) => item.keyword === "birthday")!.text = res.birthday;
        // 初回加入年月日
        resArr.find((item) => item.keyword === "joinDate")!.text =
          res.firstJoinDate;
        // 被共済職員期間
        resArr.find((item) => item.keyword === "premiumEnroll")!.text =
          (res.maePeriodYear ?? "") +
          "年" +
          (res.maePeriodMonth ?? "") +
          "ヶ月";
        // 退職日
        resArr.find((item) => item.keyword === "retireDate")!.text =
          res.retireDate;
        // 退職理由
        resArr.find((item) => item.keyword === "retireReasonCd")!.text =
          TkGetCode(RetireReason, res.retireReasonCd);
        // 支給額
        resArr.find((item) => item.keyword === "paymentAmt")!.text =
          res.paymentAmt ? changeAmountFormat(res.paymentAmt) + "円" : "";
        // 俸給表の額
        resArr.find((item) => item.keyword === "salaryTableAmt")!.text =
          res.salaryTableAmt !== undefined && res.salaryTableAmt !== null
            ? changeAmountFormat(res.salaryTableAmt) + "円"
            : "";
        // 俸給の調整額
        resArr.find((item) => item.keyword === "salaryAdjustmentAmt")!.text =
          res.salaryAdjustmentAmt !== undefined &&
          res.salaryAdjustmentAmt !== null
            ? changeAmountFormat(res.salaryAdjustmentAmt) + "円"
            : "";
        // 合計
        resArr.find((item) => item.keyword === "totalPaymentAmt")!.text =
          res.totalPaymentAmt !== undefined && res.totalPaymentAmt !== null
            ? changeAmountFormat(res.totalPaymentAmt) + "円"
            : "";

        // 訂正後
        // 被共済職員期間（職員情報訂正後）
        resArr.find(
          (item) => item.keyword === "correctedMutualAidPeriod"
        )!.node = (
          <Box className="line">
            <TkLabelText
              wantToSetValue={res.maePeriodYearAfter}
              disabled={true}
            />
            年
            <TkLabelText
              wantToSetValue={res.maePeriodMonthAfter}
              disabled={true}
            />
            ヶ月
          </Box>
        );

        // 退職理由（職員情報訂正後）
        let modifiedRetireReasonCd = resArr.find(
          (item) => item.keyword === "modifiedRetireReasonCd"
        )!;
        modifiedRetireReasonCd.setDefaultValue = res.modifiedRetireReasonCd;
        if (
          isStatusAfterAwaitingReceipt(res.latestApplyStatus) ||
          res.latestApplyStatus === Status["受理待ち"]
        ) {
          modifiedRetireReasonCd.disabled = true;
          modifiedRetireReasonCd.requiredIcon = false;
        } else {
          modifiedRetireReasonCd.disabled = false;
          modifiedRetireReasonCd.requiredIcon = true;
        }

        // 俸給表の額（職員情報訂正後）
        resArr.find(
          (item) => item.keyword === "correctedSalaryTableAmt"
        )!.setDefaultValue = res.salaryTableAmtAfter;

        // 俸給の調整額（職員情報訂正後）
        resArr.find(
          (item) => item.keyword === "correctedSalaryAdjustmentAmt"
        )!.setDefaultValue = res.salaryAdjustmentAmtAfter;

        // 合計（職員情報訂正後）
        resArr.find(
          (item) => item.keyword === "correctedSum"
        )!.setDefaultValue = res.totalPaymentAmtAfter;

        // 支給額（職員情報訂正後）
        let paymentAmtAfter = resArr.find(
          (item) => item.keyword === "correctedPaymentAmt"
        )!;
        paymentAmtAfter.setDefaultValue = res.paymentAmtAfter;
        // 追加支給額/返還額
        let addCorrectedPaymentAmt = resArr.find(
          (item) => item.keyword === "addCorrectedPaymentAmt"
        )!;
        addCorrectedPaymentAmt.setDefaultValue = res.addPaymentAmt;
        // 追加支給/返還理由
        let reason = resArr.find((item) => item.keyword === "reason")!;
        reason.setDefaultValue = res.addPaymentReason;
        if (
          isStatusAfterAwaitingReceipt(res.latestApplyStatus) ||
          res.latestApplyStatus === Status["受理待ち"]
        ) {
          reason.disabled = true;
          reason.requiredIcon = false;
        } else {
          reason.disabled = false;
          reason.requiredIcon = true;
        }

        setSixMonthsSalaryBeforeApplyList(makeSalaryList(res));
        setStateTableList(resArr);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    if (!responseData || !responseData.contractorNo) {
      handleInit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeSalaryTableAmt = (
    data: any,
    yearMonth: number,
    type: "salaryTableAmt" | "salaryAdjustmentAmt"
  ) => {
    const value = data.target.value;
    const errorKey =
      type === "salaryTableAmt"
        ? "errorSalaryTableAmt"
        : "errorSalaryAdjustmentAmt";
    const hasError = value !== 0 && !value;

    setSixMonthsSalaryBeforeApplyList((prev) =>
      prev.map((item) =>
        item.yearMonth === yearMonth
          ? {
              ...item,
              [type]: value,
              [errorKey]: hasError
                ? TkPropertyMessageGet("TKMSG_SCR0043E")
                : "",
            }
          : item
      )
    );
  };

  /**
   * 俸給テーブルを作成する
   * @param sixSalaryList
   * @param disable
   * @returns salaryBodyList
   */
  function funSalaryBodyList(): TypeTableBody[][] {
    const salaryBodyList: TypeTableBody[][] = [];

    for (const item of sixMonthsSalaryBeforeApplyList) {
      const year = item.yearMonth?.toString().slice(0, 4);
      const month = item.yearMonth?.toString().slice(4);

      let unrecognizedMonth = unrecognizedMonthList?.find((um) => {
        return (
          um.year === (Number(month) > 3 ? Number(year) : Number(year) - 1)
        );
      });
      if (
        unrecognizedMonth &&
        ["1", "3"].includes(
          unrecognizedMonth[
            monthMapping[month!] as keyof typeof unrecognizedMonth
          ] as string
        )
      ) {
        continue;
      }

      const disable =
        responseData.latestApplyStatus !== Status["届出待ち"] &&
        responseData.latestApplyStatus !== Status["差戻し一時保存"];

      const listData: TypeTableBody[] = [
        { id: `${item.yearMonth}` },
        {
          children: `${year}年${month}月`,
        },
        {
          children: (
            <TkAmountInput
              error={!!item.errorSalaryTableAmt}
              errorMessage={item.errorSalaryTableAmt}
              wantToSetValue={item.salaryTableAmt}
              inputProps={{ maxLength: 9 }}
              disabled={disable}
              onChange={(e: any) =>
                changeSalaryTableAmt(e, item.yearMonth!, "salaryTableAmt")
              }
            />
          ),
          align: "right",
        },
        {
          children: (
            <TkAmountInput
              error={!!item.errorSalaryAdjustmentAmt}
              errorMessage={item.errorSalaryAdjustmentAmt}
              wantToSetValue={item.salaryAdjustmentAmt}
              inputProps={{ maxLength: 9 }}
              disabled={disable}
              onChange={(e: any) =>
                changeSalaryTableAmt(e, item.yearMonth!, "salaryAdjustmentAmt")
              }
            />
          ),
          align: "right",
        },
      ];

      salaryBodyList.push(listData);

      if (salaryBodyList.length >= 6) break;
    }

    return salaryBodyList;
  }

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    } else {
      setMemoCheck(event.target.value);
    }
  };

  // データを作成
  const makeHttpObj = (num: string, formData?: any): IAPI_APP016_Request => {
    const req: IAPI_APP016_Request = {
      applyId: applyId,
      applyEvent: num,
      contractorNo: contractorNo,
      screenId: "SCRW070004",
      inquiryCode: memoCheck ? InquiryCode["職員"] : "",
      reason: memoData,
    };
    if (formData?.symbolNumber) {
      req.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";
      req.decisionDate = formData.settlementDate;
      req.dueDate = formData.paymentDeadline;
    }

    return req;
  };

  const btnEvent = async (btnName: keyof typeof applyEvent) => {
    const event = applyEvent[btnName];

    switch (event) {
      case applyEvent["契約者に差戻し"]:
      case applyEvent["受理"]:
      case applyEvent["担当者に差戻し"]:
      case applyEvent["課長代理確認"]:
      case applyEvent["上長承認"]:
      case applyEvent["郵送"]:
        handleSave(event);
        break;
      case applyEvent["承認"]:
        setIsOpen(true);
        break;
    }
  };

  const handleSave = async (applyEvent: any, formData?: any) => {
    // 申請状況更新API
    try {
      const res = await httpAPI_APP016({
        ...makeHttpObj(applyEvent, formData),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setIsOpen(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleRegister = () => {
    if (ref.current === null) return;
    ref.current.submit(false);
  };

  const makeHttpObjSearch = (data: any): IAPI_STA033_Request => {
    const sixMonthsSalaryBeforeApplyListObj = sixMonthsSalaryBeforeApplyList
      ?.filter((smsba) =>
        funSalaryBodyList()?.find((tb) => smsba.yearMonth === Number(tb[0].id))
      )
      .map((item) => ({
        yearMonth: item.yearMonth,
        salaryTableAmt: item.salaryTableAmt,
        salaryAdjustmentAmt: item.salaryAdjustmentAmt,
        monthlySalaryAmt:
          (item.salaryTableAmt ?? 0) + (item.salaryAdjustmentAmt ?? 0),
      }));

    return {
      applyId: responseData.applyId,
      contractorNo: contractorNo,
      facilityNo: responseData.facilityNo,
      staffNo: responseData.staffNo,
      retireDate: responseData.retireDate,
      maePeriodYear: responseData.maePeriodYearAfter ?? 0,
      maePeriodMonth: responseData.maePeriodMonthAfter ?? 0,
      totalPaymentAmt: responseData.totalPaymentAmtAfter,
      addPaymentAmt: responseData.addPaymentAmt,
      addPaymentReason: data.reason,
      unrecognizedMonthList: unrecognizedMonthList,
      sixMonthsSalaryBeforeApplyList: sixMonthsSalaryBeforeApplyListObj,
      updateDateTime: responseData.updateDateTime,
      screenId: "SCRW070004",
      retireReasonCd: responseData.retireReasonCd,
      modifiedRetireReasonCd: data.modifiedRetireReasonCd,
    };
  };

  const onCheckAndSubmit = async (data: any) => {
    setState({
      ...state,
      errorMsgId: "",
    });

    const target = sixMonthsSalaryBeforeApplyList?.filter((item) =>
      funSalaryBodyList()?.find((i) => item.yearMonth === Number(i[0].id))
    );
    if (
      target.some(
        (item) => item.errorSalaryTableAmt || item.errorSalaryAdjustmentAmt
      )
    ) {
      initErrorScrollObserver(".MuiFormHelperText-root.Mui-error");
      return;
    }

    if (target?.some((item) => (item?.salaryTableAmt ?? 0) <= 73999)) {
      // 俸給表の額 ≦ 73,999円
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0124E",
      });
      initErrorScrollObserver(".sixMonthsSalaryBeforeApplyList");
      return;
    }

    try {
      // 退職手当金追加更新
      const res = await httpAPI_STA033({
        ...makeHttpObjSearch(data),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const initErrorScrollObserver = (elements: string) => {
    const observer = new MutationObserver((_, observer) => {
      const errorElements = document.querySelectorAll(elements);

      if (errorElements.length > 0) {
        errorElements[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
        observer.disconnect();
      } else {
        observer.disconnect();
      }
    });

    const config = { childList: true, subtree: true };
    observer.observe(document.body, config);
    return observer;
  };

  const changeUnrecognizedMonthList = (value: any) => {
    setUnrecognizedMonthList(value);
  };

  return (
    <Box data-testid="SCRW070004PageForTest" className="SCRW070004">
      {/* 承認フロー */}
      {status !== "00" && status !== "16" && (
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType={responseData?.businessType}
          applicationStatus={status}
        />
      )}
      <TkFakeTable
        ref={ref}
        list={stateTableList}
        ruleSchema={schema}
        showButton={false}
        submitButtonText="申請"
        onCheckAndSubmit={onCheckAndSubmit}
      />

      {/** 俸給テーブル */}
      <Box className="sixMonthsSalaryBeforeApplyList">
        <TkTable bodyList={funSalaryBodyList()} headList={salaryTableHead} />
      </Box>

      {/** ならない月 */}
      <SCRW070004Components
        res={responseData}
        onChange={(value) => changeUnrecognizedMonthList(value)}
      />

      {/** 異動履歴 */}
      <Box className="movementHistoryList">
        <TkFakeTableLine
          title="異動履歴"
          type="multipleLinesWithBorder"
          dataList={funTransferHistoryList(responseData.movementHistoryList)}
        />
      </Box>

      {/** 育休 */}
      <TkTable
        bodyList={funInfoBodyList(responseData.childcareLeaveList)}
        headList={infoHeadTitleList}
      />

      {/** 処理履歴 */}
      <TkTable
        bodyList={funStatusBodyList(responseData.statusList)}
        headList={headList}
      />

      <TkMemo headList={headList} showTable={true} onChange={onChange} />
      {isStatusAfterApproval(responseData.latestApplyStatus) && (
        <TkTableWithNoLine
          headList={symbolHeadList}
          bodyList={makeApprovalInfoList(responseData)}
        />
      )}

      <Box className="buttonGroup">
        <TkBackButton
          mr
          useBackParam
          navigateParam={{
            applyId,
            contractorNo,
          }}
        />
        {status === "00" || status === "16" ? (
          <TkButton onClick={handleRegister}>申請</TkButton>
        ) : (
          <TkViewButtonJudgement
            flowType={"TYPE2"}
            Status={status}
            onClick={btnEvent}
          />
        )}
      </Box>

      <TkApprovalDateSymbolNumberRegistrationDialog
        open={isOpen}
        onSuccess={(e: any) => handleSave(applyEvent["承認"], e)}
        onClose={() => setIsOpen(false)}
        isScheduledPaymentDateVisible={false}
        displayOnlyPaymentDeadline={true}
      />
    </Box>
  );
};

export default SCRW070004;
